import { formatDate, timeAgo, DATE_FORMAT_MASK_WITH_TIMEZONE } from 'lib/date'
import styles from './ReviewInfo.module.scss'

type ReviewInfoProps = {
  reviewerEmail?: string
  reviewedDate?: string
}

const ReviewInfo: React.FC<ReviewInfoProps> = (props) => {
  const { reviewerEmail, reviewedDate } = props

  return (
    <div className={styles.statusInfo} data-test-id="review_info_container">
      {!!reviewerEmail && (
        <div className={styles.emailWrapper}>
          <label className={styles.reviewedLabel}>by</label>
          <div className={styles.reviewedLabelEmail} aria-label={reviewerEmail} data-cooltipz-dir="top">
            <label>{reviewerEmail}</label>
          </div>
        </div>
      )}
      {!!reviewedDate && (
        <div className={styles.dateWrapper}>
          <label className={styles.reviewedLabel}>on</label>
          <label
            data-test-id="review_info_date"
            className={styles.reviewedLabelDate}
            aria-label={formatDate(reviewedDate, DATE_FORMAT_MASK_WITH_TIMEZONE)}
            data-cooltipz-dir="top"
          >
            {timeAgo(reviewedDate)}
          </label>
        </div>
      )}
    </div>
  )
}

export default ReviewInfo
